import { MembersList } from '../../../components/Users/MembersList'
export const UsersList = () => {
    return <MembersList />
}
